import { useEffect, useRef } from "react";
import { ClientId, perClient } from "../../client-features";
import { useClientId } from "../../ClientConfig";
import { useToast } from "../../context-providers/Toast";
import { APP_VERSION } from "../../util";
import { LAST_APP_VERSION_KEY } from "../../api/auth_token";
import { lt as semverLT } from "semver";

const whatsNewPerClient: {
  [key: ClientId]: { [key: string]: string | undefined } | undefined;
} = perClient({});

export const WhatsNew = () => {
  const clientId = useClientId();
  const previousAppVersion = localStorage.getItem(LAST_APP_VERSION_KEY);
  const currentAppVersion = APP_VERSION ?? "";
  const toast = useToast();
  const hasShownToast = useRef(false);

  useEffect(() => {
    // Get what's new messages for this client
    const whatsNewForClient = whatsNewPerClient[clientId];

    // If there's no what's new config for this client, just update version and exit
    if (!whatsNewForClient) {
      localStorage.setItem(LAST_APP_VERSION_KEY, currentAppVersion);
      return;
    }

    // Check if we have a message for the current version
    const whatsNewMessage = whatsNewForClient[currentAppVersion];

    // Show toast if:
    // 1. There's a message for the current version
    // 2. AND either no previous version exists OR previous version is less than the current version
    // 3. AND we haven't already shown one.
    if (
      whatsNewMessage &&
      previousAppVersion !== currentAppVersion &&
      (!previousAppVersion ||
        semverLT(previousAppVersion, currentAppVersion)) &&
      !hasShownToast.current
    ) {
      toast.show({
        summary: "Here's what's new!",
        detail: whatsNewMessage,
        severity: "info",
        sticky: true,
      });
      hasShownToast.current = true;
    }
    localStorage.setItem(LAST_APP_VERSION_KEY, currentAppVersion);
  }, [clientId, currentAppVersion, previousAppVersion, toast]);

  return <></>;
};
